import { createContext, useContext } from 'react';
import { ChargesContextType } from './types';

export const ChargesContext = createContext<ChargesContextType | null>(null);

export const useChargesContext = () => {
    const context = useContext(ChargesContext);
    if (!context) {
        throw new Error('useChargesContext must be used within a ChargesProvider');
    }
    return context;
};
